import React from "react";
import {Brands} from "@core-ui/utility";
import {Icon} from "../components/Icon";
import {IconContainerProps} from "../types";

const CrossBrandSVG = (
  <svg fill="none" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
      fill="#E6E6E6"
    />
    <path
      d="M20.7 13.4L20.25 14L20.7 14.6L23.76 18.68C23.7823 18.7097 23.7959 18.7451 23.7992 18.782C23.8025 18.819 23.7955 18.8562 23.7789 18.8894C23.7623 18.9227 23.7367 18.9506 23.7051 18.9701C23.6736 18.9897 23.6371 19 23.6 19H11.6C11.0165 19 10.4569 19.2318 10.0444 19.6444C9.63179 20.0569 9.4 20.6165 9.4 21.2V24.8C9.4 24.853 9.37893 24.9039 9.34142 24.9414C9.30392 24.9789 9.25305 25 9.2 25C9.14695 25 9.09608 24.9789 9.05858 24.9414C9.02107 24.9039 9 24.853 9 24.8V11.6C9 10.9104 9.27393 10.2491 9.76152 9.76152C10.2491 9.27393 10.9104 9 11.6 9H23.6C23.6371 9 23.6736 9.01034 23.7051 9.02987C23.7367 9.0494 23.7623 9.07733 23.7789 9.11056C23.7955 9.14378 23.8025 9.18097 23.7992 9.21796C23.7959 9.25495 23.7823 9.29028 23.76 9.32L20.7 13.4Z"
      stroke="#333333"
      strokeWidth="2"
    />
  </svg>
);

const brandIconSVGs = {
  [Brands.Athleta]: CrossBrandSVG,
  [Brands.BananaRepublic]: CrossBrandSVG,
  [Brands.BananaRepublicFactoryStore]: CrossBrandSVG,
  [Brands.Gap]: CrossBrandSVG,
  [Brands.GapFactoryStore]: CrossBrandSVG,
  [Brands.OldNavy]: CrossBrandSVG,
  crossBrand: CrossBrandSVG,
};

export const FlagCircleIcon = (props: IconContainerProps): JSX.Element => (
  <Icon {...props} brandIconSVGs={brandIconSVGs} />
);
